// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__10s1_","insightsList":"newBusinessInsightsMenu_insightsList__2zzXH","active":"newBusinessInsightsMenu_active__2Pp8q"};